import { render, staticRenderFns } from "./NewCategoriasHomeMobile.vue?vue&type=template&id=44764c88&scoped=true&"
import script from "./NewCategoriasHomeMobile.vue?vue&type=script&lang=js&"
export * from "./NewCategoriasHomeMobile.vue?vue&type=script&lang=js&"
import style0 from "./NewCategoriasHomeMobile.vue?vue&type=style&index=0&id=44764c88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44764c88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VAlert,VChip,VCol,VContainer,VIcon,VRow,VSkeletonLoader,VSlideGroup,VSlideItem})
